import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';

// prettier-ignore
import {
    Header, Footer, IndexPage, SignUp, 
    Login, PWInquiry, IDInquiry, PWChange, 
    Mypage, NoticeIndex, NoticeDetail, FAQ,
    Event, FareIndex, FareDetail, StandbyRequestPage,
    StandbyListPage, StandbyDetailPage, ReissueRequestPage, ReissueListPage, 
    ReissueDetailPage, ScTicketRequestPage, ScTicketListPage, 
    ScTicketDetailPage,EmdRequestPage, EmdListPage, EmdDetail,    
    InvolRequestPage, InvolListPage, InvolDetailPage, 
    SeatRequestPage, SeatListPage, SeatDetailPage, GroupRequest,
    ATRRequest, ATRdetail, ATRListPage, DepositContract, EstimateConfirm,
    InvoicePrice, AncillaryPrice, IssueRequest
} from './component/pages';
import './component/cssModule';

function App() {
    const location = useLocation();
    const noFooterPaths = ['/group/deposit-contract'];
    const footerRender = !noFooterPaths.includes(location.pathname);

    // 헤더 풋터 삭제
    const noHeaderFooterPaths = ['/series/invoicePrice', '/series/ancillaryprice', '/series/issuerequest'];
    const hideLayout = noHeaderFooterPaths.includes(location.pathname);

    return (
        <>
            {/* 헤더 */}
            {!hideLayout && <Header />}
            <Routes>
                <Route path='/' element={<IndexPage />} />
                <Route path='/signup' element={<SignUp />} />
                <Route path='/login' element={<Login />} />
                <Route path='/pwinquiry' element={<PWInquiry />} />
                <Route path='/idinquiry' element={<IDInquiry />} />
                <Route path='/pwchange' element={<PWChange />} />
                <Route path='/mypage' element={<Mypage />} />
                {/* 공지사항 */}
                <Route path='/notice/:category' element={<NoticeIndex />} />
                {/* 공지사항 디테일 */}
                <Route path='/notice/:category/detail' element={<NoticeDetail />} />
                {/* 공지사항 FAQ */}
                <Route path='/notice/faq' element={<FAQ />} />
                {/* 공지사항 이벤트 */}
                <Route path='/notice/event' element={<Event />} />

                {/* 운임 안내 */}
                <Route path='/fare/:category' element={<FareIndex />} />
                {/* 운임 안내 디테일 */}
                <Route path='/fare/:category/detail' element={<FareDetail />} />

                {/* 서비스 요청 / 대기전문 요청 */}
                <Route path='/service/standbyrequest' element={<StandbyRequestPage />} />
                <Route path='/service/standbylist' element={<StandbyListPage />} />
                <Route path='/service/standbydetail' element={<StandbyDetailPage />} />

                {/* 서비스 요청 / Auto 리이슈 요청 */}
                <Route path='/service/autoreissuerequest' element={<ReissueRequestPage />} />
                <Route path='/service/reissuelist' element={<ReissueListPage />} />
                <Route path='/service/reissuedetail' element={<ReissueDetailPage />} />

                {/* 서비스 요청 / Auto 리이슈 티켓 발송요청 */}
                <Route path='/service/scticketrequest' element={<ScTicketRequestPage />} />
                <Route path='/service/scticketlist' element={<ScTicketListPage />} />
                <Route path='/service/scticketdetail' element={<ScTicketDetailPage />} />

                {/* 서비스 요청 / EMD 티켓 요청 */}
                <Route path='/service/emdticketrequest' element={<EmdRequestPage />} />
                <Route path='/service/emdticketlist' element={<EmdListPage />} />
                <Route path='/service/emdticketdetail' element={<EmdDetail />} />

                {/* 서비스 요청 / INVOL 재발행 요청 */}
                <Route path='/service/involreissuerequest' element={<InvolRequestPage />} />
                <Route path='/service/involreissuelist' element={<InvolListPage />} />
                <Route path='/service/involreissuedetail' element={<InvolDetailPage />} />

                {/* 서비스 요청 / 유료 좌석 구매 요청 */}
                <Route path='/service/seatrequest' element={<SeatRequestPage />} />
                <Route path='/service/seatlist' element={<SeatListPage />} />
                <Route path='/service/seatdetail' element={<SeatDetailPage />} />

                {/* 단체 견적 문의 */}
                <Route path='/group/bookingrequest' element={<GroupRequest />} />

                {/* 단체 발권 요청 / ATR 발권 요청 내역 */}
                <Route path='/group/atrrequest' element={<ATRRequest />} />
                <Route path='/group/atrdetail' element={<ATRdetail />} />
                <Route path='/group/atrlist' element={<ATRListPage />} />

                <Route path='/group/deposit-contract' element={<DepositContract />} />
                <Route path='/group/estimate-confirm' element={<EstimateConfirm />} />

                {/* 인보이스 확인 */}
                <Route path='/series/invoiceprice' element={<InvoicePrice />} />
                <Route path='/series/ancillaryprice' element={<AncillaryPrice />} />

                {/* 발권 내역서 ATR 발권 신청 버튼 클릭시 */}
                <Route path='/series/issuerequest' element={<IssueRequest />} />

                {/* 매칭되지 않는 모든 경로는 "/"로 이동 */}
                <Route path='*' element={<Navigate to='/' replace />} />
            </Routes>
            
            {/* 풋터 */}
            {!hideLayout && footerRender && <Footer />}
        </>
    );
}

function AppWithRouter() {
    return (
      <Router>
        <App />
      </Router>
    );
  }

export default AppWithRouter;
